module.exports = __webpack_public_path__ + "img/gift-success-head.dca423c7.png";